import {BrowserRouter, BrowserRouter as Route, Router, Routes, useLocation } from "react-router-dom";
import Aboutme from "./Components/Aboutme";
import Cta from "./Components/Cta";
import Header from "./Components/Header";
import Projects from "./Components/Projects";
import TechstackSection from "./Components/TechstackSection";
import AnimatedRoutes from "./Components/AnimatedRoutes";

function App() {

  // const location = useLocation();

  return (
    
<BrowserRouter>
      <Header />
    
     <AnimatedRoutes/>
     </BrowserRouter>
    
  );
}

export default App;
